export default {
    general: {
        show_password: 'Prikaži geslo',
        hide_password: 'Skrij geslo',
        add: 'Dodaj',
        edit: 'Uredi',
        cancel: 'Prekliči',
        save: 'Shrani',
        delete: 'Izbriši',
        search: 'Išči',
        close: 'Zapri',
        confirm: 'Potrdi',
        back: 'Nazaj',
        actions: 'Dejanja',
        yes: 'Da',
        no: 'Ne',
        loading: 'Nalaganje …',
        select: 'Izberi',
        preview: 'Predogled',
        download: 'Prenesi',
        from: 'Od',
        to: 'Do',
        show: 'Prikaži',
        hide: 'Skrij',
        download_documents: 'Prevzemi dokumente',
        no_documents_to_download: 'Ni dokumenta/ov za prenos',
    },
    owner_or_user: {
        owner_and_user: 'Lastnik/Uporabnik',
        owner: 'Lastnik',
        user: 'Uporabnik',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
        load_data: 'Pri nalaganju podatkov je prišlo do napake',
        on_add: 'Pri dodajanju je prišlo do napake',
        on_edit: 'Pri urejanju je prišlo do napake',
        on_delete: 'Pri brisanju je prišlo do napake',
        on_sort: 'Pri sortiranju je prišlo do napake',
        on_logout: 'Pri odjavi je prišlo do napake',
        on_download: 'Pri prenosu datoteke je prišlo do napake',
        no_access: 'Nimate dostopa',
    },
    api_errors: {
        not_signed_in: 'Niste prijavljeni',
        forbidden: 'Za to dejanje nimate dovoljenja',
        empty_object_key: 'Šifra objekta je obvezna',
        empty_unit_key: 'Šifra enote je obvezna',
        empty_document_type: 'Vrsta dokumenta je obvezna',
        empty_depository: 'Vložišče je obvezno',
        empty_distributor_type: 'Vrsta razdelilnika je obvezna',
        empty_supplier: 'Dobavitelj je obvezen',
        empty_date: 'Datum je obvezen',
        wrong_distributor_type: 'Napačna vrsta razdelilnika',
        wrong_date: 'Napačen datum',
        wrong_type: 'Napačna vrsta',
        not_own_unit: 'Do te enote nimate dostopa',
        not_own_object: 'Do tega objekta nimate dostopa',
        not_own_document: 'Do tega dokumenta nimate dostopa',
        no_access_to_documents: 'Do dokumentov nimate dostopa',
        no_access: 'Do te vsebine nimate dostopa',
        internal_server_error: 'Neznana notranja napaka strežnika',
        invalid_data: 'Prejeti so bili neveljavni podatki',
        not_found: 'Ni najdeno',
        unauthorized: 'Nimate dovoljenja za to dejanje',
        invalid_password: 'Geslo ni pravilno',
        invalid_email: 'Neveljaven e-poštni naslov',
        invalid_email_or_password: 'E-pošta ali geslo ni pravilno',
        invalid_file_type: 'Zapis dokumenta ni pravilen',
        invalid_captcha: 'Neveljavna captcha',
        forgotten_password_expired: 'Zahteva za pozabljeno geslo je potekla',
        invalid_bill_password: 'Neveljavno geslo iz položnice',
        user_exists_by_email: 'Uporabnik s tem e-poštnim naslovom že obstaja',
        user_exists_by_code_payer: 'Uporabnik s to šifro plačnika že obstaja',
        no_code_payer: 'Šifra plačnika ne obstaja',
        manager_missing: 'Manjkajo podatki upravitelja',
        user_not_connected_to_manager: 'Uporabnik ni povezan z upravnikom',
    },
    success: {
        add: 'Dodajanje je bilo uspešno',
        edit: 'Urejanje je bilo uspešno',
        delete: 'Brisanje je bilo uspešno',
        sort: 'Sortiranje je bilo uspešno',
    },
    confirm: {
        default: 'Ste prepričani, da želite nadaljevati?',
        delete_row: 'Ste prepričani, da želite izbrisati {name}',
    },
    validation: {
        required: 'To polje je obvezno',
        email: 'Neveljaven e-poštni naslov',
        min_length: 'Vnesite vsaj {min} znakov',
        at_least_one_uppercase: 'Geslo mora vsebovati vsaj eno veliko črko',
        at_least_one_digit: 'Geslo mora vsebovati vsaj eno številko',
        passwords_must_match: 'Gesli se ne ujemata',
    },
    navigation: {
        menu: 'Meni',
        quick_overview: 'Hitri pregled',
        billing: 'Obračuni',
        regular_billing: 'Redni obračun',
        reserve_fund_billing: 'Obračun rezervni sklad',
        open_items: 'Odprte postavke',
        tenants_open_items: 'Odprte postavke najemnikov',
        card_traffic: 'Kartica obračunov s plačili',
        readings: 'Obračuni toplote',
        funds: 'Skladi',
        reserve_fund: 'Rezervni sklad',
        voluntary_fund: 'Prostovoljni sklad',
        reserve_fund_debtors: 'Dolžniki rezervnega sklada',
        turnover_reserve_fund_books: 'Promet knjižb RS',
        documents: 'Dokumenti',
        manager_documents: 'Dokumenti upravnika',
        supplier_documents: 'Dokumenti dobaviteljev',
        notifications: 'Obvestila',
        your_units: 'Vaše enote',
        bulletin_board: 'Oglasna deska',
        faq: 'Pogosta vprašanja',
        contractors: 'Izvajalci',
        cost_specification: 'Specifikacija stroškov',
        registered_people_and_dogs: 'Prijavljena št. oseb in psov',
        insurance_contracts: 'Zavarovalne pogodbe',
        forms: 'Obrazci',
        profile: 'Profil',
        change_password: 'Spremeni geslo',
        add_manager: 'Dodaj upravnika',
        logout: 'Odjava',
    },
    billing: {
        cost_distributors: 'Razdelilniki stroškov:',
        naziv: 'Naziv',
        skupaj_eur: 'Skupaj (€)',
        osnova_za_ddv: 'Osnova za DDV',
        ddv_skupaj: 'DDV skupaj',
        skupaj_stroski: 'Skupaj stroški',
        skupaj_poraba_sred_rezervnega_sklada: 'Skupaj poraba sred. rezervnega sklada',
        skupni_znesek_za_placilo: 'Skupni znesek za plačilo',
        ddv: 'DDV',
        stopnja_pct: 'Stopnja (%)',
        osnova_za_ddv_eur: 'Osnova za DDV (€)',
        znesek_za_ddv_eur: 'Znesek za DDV (€)',
        skupaj_poraba_prostovoljno_zbranih_sredstev: 'Skupaj poraba prostovoljno zbranih sredstev',
        skupaj_poraba_rezervnega_sklada: 'Skupaj poraba rezervnega sklada',
        vse_skupaj: 'Vse skupaj',
        ni_podatkov_za_prikaz: 'Ni podatkov za prikaz',
        skupaj: 'Skupaj',
        skupaj_ddv_eur: 'Skupaj DDV (€)',
        skupaj_za_placilo_enota: 'Skupaj za plačilo enota',
        vse_skupaj_za_placilo: 'Vse skupaj za plačilo',
        rekapitulacija_po_ddv_stopnjah: 'Rekapitulacija po DDV stopnjah',
        celoten_znesek_eur: 'Celoten znesek (€)',
        kljuc_delitve: 'Ključ delitve',
        kolicina: 'Količina',
        sk_kol: 'Sk. kol.',
        cena_za_razdelitve_eur: 'Cena za razdelitve (€)',
        stopnja_ddv_pct: 'Stopnja DDV (%)',
        znesek_ddv_eur: 'Znesek DDV (€)',
        vrsta_stroska: 'Vrsta stroška',
        interna_st: 'Interna št',
        st_orig_rac: 'Št. orig. rač',
        datum_racuna: 'Datum računa',
        poraba_sredstev_rezervnega_sklada: 'PORABA SREDSTEV REZERVNEGA SKLADA',
        opis: 'Opis',
        oprema_storitev: 'Oprema storitev',
        ds_id_za_ddv: 'DŠ/ID za DDV',
        dobavitelj: 'Dobavitelj',
        sedez: 'Sedež',
        stroski: 'Stroški',
        poraba: 'Poraba',
        datum_od_do: 'Datum od-do',
        strosek: 'Strošek',
        osnova_ddv_eur: 'Osnova DDV (€)',
        ddv_eur: 'DDV (€)',
    },
    distributor: {
        razdelilnik_stroskov: 'Razdelilnik stroškov',
        sifra_placnika: 'Šifra plačnika',
        referenca_za_placilo: 'Referenca za plačilo',
        st_racuna_za_placilo: 'Št. računa za plačilo',
        ds_id: 'DŠ/ID',
        naziv_objekta: 'Naziv objekta',
        naziv_vhoda: 'Naziv vhoda',
        no_chart_data: 'Ni podatkov za izris grafa',
    },
    home: {
        latest_bulletin: 'Zadnje obvestilo',
        no_bulletins: 'Na oglasni deski ni obvestil',
        no_notifications: 'Ni obvestil za prikaz',
    },
    units: {
        no_active_title: 'Ni aktivnih enot',
        no_active_body: 'Za izbranega upravnika {manager} trenutno nimate nobene aktivne enote. Izberite drugega upravnika ali se obrnite nanj za več informacij.',
    },
    card_traffic: {
        payment_date_note: '(v primeru večih delnih plačil se za DATUM PLAČILA upošteva datum zadnjega plačila)',
        consumption_note: '*Kot Poraba se razume, črpanje sredstev iz rezervnega ali prostovoljnega sklada ali iz morebitnih preplačil kupca',
    },
    open_items: {
        saldo_ro: 'Saldo - redni obračun (RO)',
        saldo_rs: 'Saldo - obračun rezervni sklad (RS)',
        saldo_total: 'Skupni saldo',
        tenants_total: 'Skupaj odprte postavke najemnikov',
        ro: 'RO',
        rs: 'RS',
    },
    tenants: {
        zap_st: 'Zap. št.',
        partner: 'Partner',
        skupaj_partner: 'Skupaj partner',
        vse_skupaj: 'Vse skupaj',
    },
    registered: {
        note: '(prikazani podatki veljajo za tekoče obdobje, kar se lahko razlikuje od podatkov na razdelilnikih, ki veljajo praviloma za pretekli mesec)',
        ulica_hisna_stevilka: 'Ulica in hišna številka',
        postna_stevilka_kraj: 'Poštna številka in kraj',
        stevilo_oseb: 'Število oseb',
        stevilo_psov: 'Število psov',
        vhod: 'Vhod',
        skupaj_vhod: 'Skupaj vhod',
        skupaj_objekt: 'Skupaj objekt',
    },
    manager_documents: {
        main_depository: 'Glavno vložišče',
        depository: 'Vložišče',
    },
    readings: {
        heat_energy: 'Toplotna energija',
        hot_water: 'Topla voda',
        cold_water: 'Hladna voda',
    },
    notifications: {
        empty: 'Trenutno ni nobenih obvestil.',
    },
    fields: {
        unit_no: 'Št. enote',
        parcel: 'Parcela',
        size_net: 'Velikost neto',
        size_gross: 'Velikost bruto',
        breme_eur: 'Breme (€)',
        datum_dokumenta: 'Datum dokumenta',
        datum_placila: 'Datum plačila',
        datum_pogodbe: 'Datum pogodbe',
        datum_valute: 'Datum valute',
        datum_veljavnosti_do: 'Datum veljavnosti do',
        datum_veljavnosti_od: 'Datum veljavnosti od',
        datum: 'Datum',
        depoziti_eur: 'Depoziti (€)',
        dobro_eur: 'Dobro (€)',
        dvigi_eur: 'Dvigi (€)',
        email: 'Email',
        faktor: 'Faktor',
        gurs_st_enote: 'GURS št. enote',
        gurs_st_stavbe: 'GURS št. stavbe',
        izberite_enoto: 'Izberite enoto',
        leto: 'Leto',
        mesec: 'Mesec',
        naziv_izvajalca: 'Naziv izvajalca',
        naziv_partnerja: 'Naziv partnerja',
        naziv_stroska: 'Naziv stroška',
        naziv_zavarovalnice: 'Naziv zavarovalnice',
        naziv: 'Naziv',
        neplacano_eur: 'Neplačano (€)',
        nosilec_stroska: 'Nosilec stroška',
        objekt: 'Objekt',
        obracun: 'Obračun',
        opis: 'Opis',
        opomba: 'Opomba',
        otvoritev_11_eur: 'Otvoritev (1.1.) (€)',
        placano_eur: 'Plačano (€)',
        placila_eur: 'Plačila (€)',
        poraba_eur: 'Poraba (€)',
        porabastar_eur: 'Poraba* (€)',
        prenesi_dokumente: 'Prenesi dokumente',
        saldo_eur: 'Saldo (€)',
        sestevek_v_dobro_eur: 'Seštevek v dobro (€)',
        sklic: 'Sklic',
        skupaj: 'Skupaj',
        skupni_prostori: 'Skupni prostori',
        stanje_eur: 'Stanje (€)',
        stanje_sredstev: 'Stanje sredstev',
        stanje_terjatev: 'Stanje terjatev',
        telefon: 'Telefon',
        terjano_eur: 'Terjano (€)',
        terjatev_eur: 'Terjatev (€)',
        vrsta_prostovoljnega_sklada: 'Vrsta prostovoljnega sklada',
        vrsta_zavarovanja: 'Vrsta zavarovanja',
        vrsta: 'Vrsta',
        zaporedna_st_enote: 'Zaporedna št. enote',
        znesek_po_obracunu_eur: 'Znesek po obračunu (€)',
        znesek_premije_eur: 'Znesek premije (€)',
        znesek_stroskov_eur: 'Znesek stroškov (€)',
        odliv_eur: 'odliv (€)',
        priliv_eur: 'priliv (€)',
        stevilka_pogodbe: 'Številka pogodbe',
        gurs_st_dela_stavbe: 'GURS št. dela stavbe',
        solastniski_delez: 'Solastniški delež',
        ogrevalna_povrsina: 'Ogrevalna površina',
        vrsta_enote: 'Vrsta enote',
        vrsta_prostora: 'Vrsta prostora',
        st_oseb: 'Št. oseb',
        st_psov: 'Št. psov',
        invent_st: 'Invent. št.',
        zap_st_enote: 'Zap. št. enote',
        solast_del: 'Solast. del.',
        enota: 'Enota',
    },
    pages: {
        chart_view: 'Grafični prikaz',
        cost_chart: 'Stroškovni graf',
        virtual_reserve_fund: 'Navidezno stanje rezervnega sklada',
        download_e_invoice: 'Prenesi eRačun',
        show_e_invoice: 'Prikaži eRačun',
        download_invoices: 'Prenesi fakture',
    },
    forms: {
        title: 'Obrazci',
        change_people_or_animals: 'Obrazec za spremembo števila ljudi ali psov',
        spectator_notice: 'Ogledujete si profil drugega uporabnika. Pošiljanje obrazca je onemogočeno.',
        full_name: 'Ime in priimek',
        declaration: 'Izjava',
        declaration_from: 'Izjavljam, da posamezno enoto od:',
        declaration_uses: 'uporablja',
        declaration_users_and: 'uporabnikov in da v posamezni enoti biva',
        declaration_dogs: 'psov.',
        people_count: 'Št. uporabnikov',
        dogs_count: 'Št. psov',
        signature_notice: 'S svojim podpisom jamčim za verodostojnost podatkov. Ta izjava se uporablja za obračun vseh obratovalnih stroškov, ki se delijo v večstanovanjski stavbi, na podlagi merila delitve stroškov po številu uporabnikov.',
        send: 'Pošlji',
        send_success: 'Obrazec je bil uspešno poslan',
        send_error: 'Pri pošiljanju obrazca je prišlo do napake',
    },
    profile: {
        title: 'Profil',
        name: 'Naziv',
        address: 'Naslov',
        post_code: 'Pošta',
        city: 'Mesto',
        country: 'Država',
        code: 'Šifra',
        change_email: 'Spremeni e-pošto',
        email_updated: 'E-pošta je bila uspešno posodobljena',
        email_update_error: 'Pri posodabljanju e-pošte je prišlo do napake',
    },
    regular_billing: {
        date: 'Datum',
        year_month: 'Leto/mesec',
        cost_split: 'Delitev stroška',
        e_invoice: 'eRačun',
    },
    supplier_documents: {
        period: 'Obdobje',
        supplier: 'Dobavitelj',
    },
    unit: {
        label: 'Enota',
        search: 'Išči enoto …',
    },
    footer: {
        all_rights_reserved: 'Vse pravice pridržane',
    },
    manager: {
        label: 'Upravnik',
        search: 'Išči upravnika …',
        no_results: 'Ni zadetkov',
        switch_success: 'Upravnik je uspešno zamenjan',
        switch_error: 'Prišlo je do napake pri menjavi upravnika',
    },
    table: {
        empty: 'Ni podatkov za prikaz',
        reload: 'Osveži',
        clear_filters: 'Počisti filtre',
        search_by: 'Išči po {field}',
        pick_option: 'Izberi možnost',
        pick_date: 'Izberi datum',
        page_report: '{first} - {last} od {total}',
        press_enter: 'Pritisni enter za iskanje',
        total: 'Skupaj:',
    },
    editor: {
        images_not_allowed: 'Vstavljanje slik ni dovoljeno!',
        audio_not_allowed: 'Vstavljanje zvoka ni dovoljeno!',
        video_not_allowed: 'Vstavljanje videa ni dovoljeno!',
    },
    upload: {
        file: 'Datoteka',
        files_and_photos: 'Datoteke in fotografije',
        drop_hint: 'Povlecite in spustite datoteke za nalaganje.',
        uploaded: 'Naloženo',
        clear: 'Odstrani',
    },
    login: {
        email: 'E-pošta',
        password: 'Geslo',
        remember_me: 'Zapomni si me',
        forgotten_password: 'Pozabljeno geslo?',
        register: 'Registracija',
        submit: 'Vstopi',
        error: 'Vaša e-pošta ali geslo ne ustreza podatkom iz registracije',
    },
    register: {
        submit: 'Registracija',
        to_login: 'Prijava',
        success: 'Registracija je bila uspešna',
        error: 'Pri registraciji je prišlo do napake',
    },
    add_manager: {
        title: 'Dodaj upravnika',
        submit: 'Dodaj upravnika',
        success: 'Nov upravnik je uspešno dodan',
        spectator_notice: 'Ogledujete si profil drugega uporabnika. Dodajanje upravnika je onemogočeno.',
    },
    change_password: {
        password_help: 'Geslo mora biti dolgo vsaj 8 znakov ter vsebovati vsaj eno veliko črko in eno številko.',
        spectator_notice: 'Ogledujete si profil drugega uporabnika. Spreminjanje gesla je onemogočeno.',
        title: 'Spremeni geslo',
        current: 'Trenutno geslo',
        new: 'Novo geslo',
        repeat: 'Potrdi geslo',
        submit: 'Spremeni geslo',
        success: 'Geslo je bilo uspešno spremenjeno',
        error: 'Pri spremembi gesla je prišlo do napake',
    },
    forgotten_password: {
        title: 'Pozabljeno geslo',
        intro: 'Spodaj vnesite svoj e-poštni naslov in poslali vam bomo navodila za ponastavitev vašega gesla.',
        submit: 'Ponastavi geslo',
        sent_title: 'Navodila za ponastavitev gesla poslana!',
        sent_body: 'Na vpisan e-poštni naslov so bila uspešno poslana navodila, kako ponastaviti geslo. Geslo je potrebno ponastaviti v 24 urah.',
        back_to_login: 'Nazaj na prijavo',
        captcha_error: 'Pri reševanju captche je prišlo do napake. Prosimo osvežite stran.',
        send_error: 'Pri pošiljanju e-pošte je prišlo do napake',
    },
    reset_password: {
        title: 'Ponastavite geslo',
        intro: 'Spodaj vnesite novo geslo.',
        new: 'Novo geslo',
        repeat: 'Ponovite geslo',
        submit: 'Ponastavi geslo',
        success: 'Ponastavitev gesla je bila uspešna!',
        error: 'Pri ponastavitvi gesla je prišlo do napake',
    },
    connect_manager: {
        title: 'Pred ponovno prijavo morate povezati upravnika',
    },
    login_as_user: {
        failed_title: 'Pri vpisu je prišlo do napake!',
        failed_body: 'Zaprite zavihek in ponovno poskusite na admin portalu.',
    },
    not_found: {
        title: 'Stran ni najdena!',
        subtitle: 'Iskane strani žal nismo našli.',
        back_home: 'Nazaj na začetno stran',
    },
    user: {
        title: 'Uporabniki',
        add: 'Dodaj uporabnika',
        firstname: 'Ime',
        lastname: 'Priimek',
        email: 'E-pošta',
        code_payer: 'Šifra plačnika',
        address: 'Naslov',
        post_code: 'Pošta',
        city: 'Kraj',
        post_and_city: 'Pošta in kraj',
        password: 'Geslo',
        password_help: 'Geslo mora biti dolgo vsaj 8 znakov ter vsebovati vsaj eno veliko črko in eno številko.',
        bill_password: 'Geslo iz položnice',
        bill_password_help: 'Geslo najdete na računu.',
        generate: 'Generiraj',
        check_email: 'Preveri e-pošto uporabnika',
        enter_valid_email: 'Vnesite pravilen e-poštni naslov',
        change_password: 'Spremeni geslo',
        change_user_password: 'Spremeni geslo uporabnika',
        switch_to: 'Preklopi',
        switch_error: 'Prišlo je do napake pri preklopu na uporabnika',
        export: 'Izvoz uporabnikov',
        export_error: 'Prišlo je do napake pri izvozu uporabnikov',
        unlink: 'Odpoveži',
        unlink_confirm: 'Ali ste prepričani, da želite odpovezati uporabnika: {firstname} {lastname} - {code_payer}?',
        unlink_success: 'Uporabnik je uspešno odpovezan',
        unlink_error: 'Prišlo je do napake pri odpovezavi uporabnika',
    },
    partner: {
        title: 'Partnerji',
        name: 'Naziv',
        code: 'Šifra',
        address: 'Naslov',
        post_code: 'Pošta',
        city: 'Kraj',
        password: 'Geslo',
        password_set: 'Geslo je nastavljeno',
        password_not_set: 'Geslo ni nastavljeno',
        switch_to: 'Preklopi',
        switch_error: 'Prišlo je do napake pri preklopu na partnerja',
    },
    depository: {
        title: 'Vložišča',
        add: 'Dodaj vložišče',
        base: 'Osnovno vložišče',
        display_name: 'Prikazan naziv',
        content: 'Vsebina vložišča',
        content_of: 'Vsebina vložišča: {name}',
        delete_name: 'vložišče: {name}?',
        filter_by_building: 'Filtriraj po objektu',
        document_name: 'Naziv',
        subject: 'Zadeva',
        partner: 'Partner',
        document_date: 'Datum dokumenta',
        format: 'Format',
        no_file: 'Dokument nima datoteke',
        download_error: 'Prišlo je do napake pri prenosu dokumenta',
    },
    bulletin: {
        title: 'Oglasna deska',
        add: 'Dodaj obvestilo',
        edit: 'Uredi obvestilo',
        name: 'Naslov',
        content: 'Vsebina',
        buildings: 'Objekti',
        pick_buildings: 'Izberi objekte',
        limit_to_buildings: 'Omejitev na objekte',
        limited_to_building: 'Omejeno na objekt',
        active: 'Aktivno obvestilo',
        delete_name: 'obvestilo: {title}?',
        empty: 'Trenutno ni nobenih elementov na oglasni deski',
    },
    faq: {
        title: 'Pogosta vprašanja',
        add: 'Dodaj vprašanje',
        position: 'Vrstni red',
        question: 'Vprašanje',
        answer: 'Odgovor',
        delete_name: 'vprašanje: {question}?',
    },
    allowed_pages: {
        title: 'Dovoljene strani',
        page_name: 'Naziv strani',
        pages: {
            regular_billing: 'Redni obračun',
            reserve_fund_billing: 'Obračun rezervni sklad',
            open_items: 'Odprte postavke',
            card_traffic: 'Kartica obračunov s plačili',
            readings: 'Obračuni toplote',
            reserve_fund: 'Rezervni sklad',
            voluntary_fund: 'Prostovoljni sklad',
            reserved_fund_debtors: 'Dolžniki rezervnega sklada',
            reserved_fund_postings: 'Promet knjižb rezervnega sklada',
            manager_documents: 'Dokumenti upravnika',
            supplier_documents: 'Dokumenti dobaviteljev',
            notifications: 'Obvestila',
            your_units: 'Vaše enote',
            bulletin_board: 'Oglasna deska',
            faq: 'Pogosta vprašanja',
            contractors: 'Izvajalci',
            cost_specification: 'Specifikacija stroškov',
            tenants: 'Najemniki',
            registered_people_and_dogs: 'Prijavljena št. oseb in psov',
            insurance_contracts: 'Zavarovalne pogodbe',
        },
    },
}
